import { render, staticRenderFns } from "./Member.vue?vue&type=template&id=5e4c84de&scoped=true&"
import script from "./Member.vue?vue&type=script&lang=js&"
export * from "./Member.vue?vue&type=script&lang=js&"
import style0 from "./Member.vue?vue&type=style&index=0&id=5e4c84de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c84de",
  null
  
)

component.options.__file = "Member.vue"
export default component.exports